// extracted by mini-css-extract-plugin
export default {"container":"sl-z","blurb":"tl-z","links":"ul-z"};